import { type ContactRequestV1 } from '@redteclab/api/clients/contact-service'

import { type ContactFormValues } from './ContactFormValues'

const buildMessage = ({
  message,
  phoneNumber,
  productCode,
}: Pick<
  ContactFormValues,
  'message' | 'phoneNumber' | 'productCode'
>): string => {
  const details = [
    phoneNumber ? `(phoneNumber: ${phoneNumber})` : '',
    productCode ? `(Product Pzns: [${productCode}])` : '',
  ].filter(Boolean)

  return [message, ...details].join(' ')
}

export const directContactFormBuildContactRequest = ({
  imageIds,
  values,
}: {
  imageIds: string[]
  values: ContactFormValues
}): ContactRequestV1 => ({
  email: values.email,
  fcSolution: values.fcSolution,
  firstName: values.firstName,
  images: imageIds,
  lastName: values.lastName,
  message: buildMessage(values),
  orderId: values.orderId || undefined,
  productCode: values.productCode || undefined,
  subject: values.subject,
})
